import loadable from "@loadable/component";


export default loadable(() => import(/* webpackChunkName: "PaymentView.D" */ "./Loadable"));
